module.exports = __webpack_public_path__ + "img/zyrtec_allergy_10_mg_tablets.c783beb8.jpg";